import React from 'react';
import { UserButton } from '@clerk/clerk-react';

interface PageHeaderProps {
  title: React.ReactNode;
  backButton?: { label: string; onClick: () => void };
}

export function PageHeader({ title, backButton }: PageHeaderProps) {
  return (
    <div
      className="page-header-row"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 'var(--space-6)',
        paddingBottom: 'var(--space-4)',
        borderBottom: '1px solid var(--color-border)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
        {backButton && (
          <button
            onClick={backButton.onClick}
            className="btn-touch"
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-cyan)',
              cursor: 'pointer',
              fontSize: 'var(--text-base)',
              padding: 'var(--space-2)',
            }}
          >
            ← {backButton.label}
          </button>
        )}
        <h1 style={{ margin: 0, fontSize: 'var(--text-xl)', fontWeight: 700 }}>
          {title}
        </h1>
      </div>
      <UserButton afterSignOutUrl="/sign-in" />
    </div>
  );
}
